"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_SLA_TIER_LIST = void 0;
var _actionify = require("@mulesoft/actionify");
var FETCH_SLA_TIER_LIST = exports.FETCH_SLA_TIER_LIST = (0, _actionify.buildActionsFor)('Fetch SLA tier list');
//# sourceMappingURL=actionTypes.js.map